// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ITransactionTagDto
 */
export interface ITransactionTagDto {
    /**
     * 
     * @type {string}
     * @memberof ITransactionTagDto
     */
    tag?: string;
    /**
     * 
     * @type {string}
     * @memberof ITransactionTagDto
     */
    tag_category?: string;
}

/**
 * Check if a given object implements the ITransactionTagDto interface.
 */
export function instanceOfITransactionTagDto(value: object): value is ITransactionTagDto {
    return true;
}

export function ITransactionTagDtoFromJSON(json: any): ITransactionTagDto {
    return ITransactionTagDtoFromJSONTyped(json, false);
}

export function ITransactionTagDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ITransactionTagDto {
    if (json == null) {
        return json;
    }
    return {
        
        'tag': json['tag'] == null ? undefined : json['tag'],
        'tag_category': json['tag_category'] == null ? undefined : json['tag_category'],
    };
}

export function ITransactionTagDtoToJSON(json: any): ITransactionTagDto {
    return ITransactionTagDtoToJSONTyped(json, false);
}

export function ITransactionTagDtoToJSONTyped(value?: ITransactionTagDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tag': value['tag'],
        'tag_category': value['tag_category'],
    };
}

